
import './App.css';
import SearchMovie from './searchMovie';

function App() {
  return (
    <div className="App">
       <h1>Movies search</h1>
       <SearchMovie />
    </div>
  );
}

export default App;
